module.exports = __webpack_public_path__ + "static/media/filled_tag.dafbd28e.svg";